import { createReducer } from '@reduxjs/toolkit'
import { setModalAddFieldsVisible, showModalAddFields } from './modal-add-fields.actions'
import { Setup } from '../../../models/interfaces/setup.interface'
import { WorkoutTypeEnum } from '../../../models/enums/workout-type.enum'

export type ModalAddFields = {
  setup: Setup[]
  id: string
  workoutType: WorkoutTypeEnum
}

export interface ModalState {
  isVisible: boolean
  data: ModalAddFields | null
}

const initialState: ModalState = {
  isVisible: false,
  data: null
}

export const modalAddFieldsReducer = createReducer(initialState, builder => {
  builder
    .addCase(setModalAddFieldsVisible, (state, action) => {
      state.isVisible = action.payload
    })
    .addCase(showModalAddFields, (state, action) => {
      state.data = action.payload.data
      state.isVisible = action.payload.isVisible
    })
})
